import React from 'react';
import './Skills.scss';
import { images } from '../../constants';
import { motion } from 'framer-motion';
import { AppWrap, MotionWrap } from '../../wrapper';

const skillSet = [
    { name: 'HTML', imgUrl: images.html},
    { name: 'CSS', imgUrl: images.css},
    { name: 'React', imgUrl: images.react1},
    { name: 'NodeJS', imgUrl: images.node},
    { name: 'Firebase', imgUrl: images.firebase},
    { name: 'ExpressJS', imgUrl: images.expressjs},
    { name: 'Figma', imgUrl: images.figma},
    { name: 'Git', imgUrl: images.git},
    { name: 'Tailwind', imgUrl: images.tailwind},
    { name: 'Wordpress', imgUrl: images.wordpress},
    { name: 'Photoshop', imgUrl: images.photoshop},
    { name: 'Illustrator', imgUrl: images.illustrator},
]

const Skills = () => {
    return (
        <>
            <h2 className='head-text'>My Skills</h2>
            <div className='app__skills-container'>
                <motion.div className='app__skills-list'>
                    {skillSet.map((skill)=> (
                        <motion.div
                        whileInView={{opacity: [0, 1]}}
                        transition={{duration: 0.5}}
                        className="app__skills-item app__flex"
                        key={skill.name}
                        >
                            <div className="app__flex" style={{backgroundColor: skill.bgColor}}>
                                <img src={skill.imgUrl} alt="skill-icon" />
                            </div>
                            <p className="p-text">{skill.name}</p>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </>
    );
};

export default AppWrap(
    MotionWrap(Skills, 'app__skills'),
    'skills',
    'app__whitebg',
  );